import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PrimarySuffixLabel } from 'components/KBQSelect'

const initialState: PrimarySuffixLabel[] = []
const primarySuffixLabel = createSlice({
  name: 'PrimarySuffixLabel',
  initialState,
  reducers: {
    setPrimarySuffixLabel(state, action: PayloadAction<PrimarySuffixLabel>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})
export const { setPrimarySuffixLabel } = primarySuffixLabel.actions
export default primarySuffixLabel.reducer
